import React from 'react';
import './ModalSistema.css';

function ModalConfirm({
  open,
  onClose,
  title = 'Confirmação',
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  onConfirm,
  variant = 'primary'
}) {
  if (!open) return null;

  const handleConfirm = () => {
    if (typeof onConfirm === 'function') onConfirm();
    onClose();
  };

  const btnClass = variant === 'danger' ? 'btn-danger' : variant === 'success' ? 'btn-success' : 'btn-primary';

  return (
    <div className="modal-sistema-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="modal-confirm-title">
      <div className="modal-sistema-card" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 420 }}>
        <h5 className="modal-sistema-title mb-2" id="modal-confirm-title">{title}</h5>
        <p className="modal-sistema-message text-muted small mb-3">{message}</p>
        <div className="d-flex justify-content-end gap-2">
          <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>{cancelLabel}</button>
          <button type="button" className={`btn ${btnClass} btn-sm`} onClick={handleConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}

export default ModalConfirm;
